import React from "react";
import Wrp from '../../../../hoc/Wrp/Wrp';
import Icons from "../../../../Components/Icons/Icons";

const folderSection = (props) => {
  //console.log(JSON.parse(props.directoryLists), 'directoryLists')
  let directorylists = JSON.parse(props.directoryLists);
  let folderListsHtml = '';
  // console.log(directorylists, 'directorylists')
  const highlightedDirectoryId = props.activeSidebarDirectoryId || props.ListingDirectoryID;
  folderListsHtml = directorylists.map((directory,index) => {
    //console.log(directory, 'directory')
    let isShow = 'close';
    if(props.istoggleDirectoryAction === directory.id){
      isShow = 'show';
    }

    let isActive = "";
    if(highlightedDirectoryId === directory.id){
      isActive = "selected";  
    }

    return(
        <>
        <div className="card-list p-0" style={{borderBottom:'1px solid rgb(229, 229, 229)'}}>
          <div   
            style={{padding:'10px', cursor: 'pointer'}} 
            key={index} 
            className={`${isActive} item-list`}
            onClick={e=>props.assignListingModules('Directory',directory.id, directory, 'sidebar')}
          >
            <div className="info-user ml-2 w-50 pr-1 d-flex align-items-center">
              <span className="selectgroup-button-icon pl-0">
                <Icons iconType="Folder" />
              </span>
              <div class="table_dots" title={directory.name}><span key={index} className="text-medium text-truncate mr-5" >{directory.name}</span></div>
            </div>
            <div className="btn-group" onClick={e => e.stopPropagation()}>
              {directory.non_editable !== true ? 
                <button type="button" className="btn btn-border border-default"   onClick={e=>props.editFolderHandler(directory)}><Icons iconType="Edit" />  </button>
              : null}

              <button type="button" className="btn btn-border border-default" data-toggle="dropdown" title=" ">
                <Icons iconType={'ThreeDot'} />
              </button>
                <ul key={index} className={`dropdown-menu dropdown-menu-right border p-0 m-0 dropnotHide`}>
                  <li><a className="dropdown-item" onClick={e=>props.toggleSubFolderPopup(directory.id)}>Create Sub Folder</a></li>
                  {directory.non_editable !== true ? <li><a className="dropdown-item" onClick={e=>props.deleteDirectoryHandler(directory.id)}>Delete</a></li> : null}
                  <li><a className="dropdown-item" onClick={e=>props.downloadDirectoryHandler (directory.id)}>Download</a></li>
                </ul>
              
            </div>
          </div>
        </div>
        </>  
    )
  })
    return(
        <Wrp>
            <div className="text-right cursor-pointer text-info m-2" data-toggle="modal" data-target="#createFolder" onClick={props.toggleFolderPopup}>
            <i className="fas fa-plus fa-lg primary_color" ></i> Add Folders </div>
            {folderListsHtml}              
        </Wrp>
    )
}

export default folderSection;